import { render, staticRenderFns } from "./EconomicCalculationSection.vue?vue&type=template&id=47ffc3f8&scoped=true&"
import script from "./EconomicCalculationSection.vue?vue&type=script&lang=ts&"
export * from "./EconomicCalculationSection.vue?vue&type=script&lang=ts&"
import style0 from "./EconomicCalculationSection.vue?vue&type=style&index=0&id=47ffc3f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ffc3f8",
  null
  
)

export default component.exports